import React, {useContext, useState} from 'react';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import {services} from '../../services/api'
import {NotificacionContext} from "../../context/notificacion_context";
import {IconButton} from '@mui/material';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart'
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import Badge from '@mui/material/Badge';
import {useNavigate} from "react-router-dom";
import CloseIcon from '@mui/icons-material/Close'
import {CircularProgress, Backdrop} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import Tooltip from '@mui/material/Tooltip';
import {formatoMXN} from '../../utils/moneyFormat';
import ShoppingCartOutlinedIcon from '@mui/icons-material/ShoppingCartOutlined';

export default function Carrito() {
    const navigate = useNavigate();
    const [infoCarrito, setInfoCarrito] = useState([]);
    const [totalCarrito, setTotalCarrito] = useState(0);
    const [descCarrito, setDescCarrito] = useState(0);
    const [isValid, setIsValid] = useState(true);
    const [loading, setLoading] = useState(false);
    const [serviceTemporarilyDisabled, setServiceTemporarilyDisabled] = useState(false);

    const cartStorage = JSON.parse(localStorage.getItem("idsSeleccionados") || "[]");

    const {showNotification} = useContext(NotificacionContext);
    const [state, setState] = React.useState({
        right: false
    });

    const toggleDrawer = (anchor, open) => (event) => {
        if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
            return;
        }
        setState({...state, [anchor]: open});
    };

    const pagarTaller = async () => {
        setLoading(true);
        const idTalleres = JSON.parse(localStorage.getItem("idsSeleccionados") || "[]");
        const idAlumno = localStorage.getItem("id");
        const body = {
            alumno: idAlumno,
            talleres: idTalleres
        };

        if (idAlumno) {
            const {status, data} = await services("POST", "carrito", body);

            if (status === 200) {
                showNotification("success", "linea de Captura Generada", "", null, 4);
                navigate("/mis-cursos");
            }

            if (status === 425) {
                setIsValid(false);
                data.periodos?.forEach((item) => {
                    if (item.error) {
                        showNotification("error", item.error, "", null, 4);
                    }
                });
            }
        }

        setLoading(false);
    };

    const infoTaller = async () => {
        const idTa = JSON.parse(localStorage.getItem("idsSeleccionados") || "[]");
        const idA = localStorage.getItem("id");
        const body = {
            "consulta": 1,
            "talleres": idTa
        }

        if (idA) {
            const {status, data} = await services("POST", `carrito`, body);

            setIsValid(data.isValid);

            setInfoCarrito(data.conceptos);
            setTotalCarrito(data.total);
            setDescCarrito(data.total_descuento);

            if (status === 201) {
            }

            if (status === 400) {
                setIsValid(false);
                data.conceptos?.forEach((item) => {
                    item.errores?.forEach((mensaje) => {
                        showNotification("error", mensaje, "", null, 4);
                    });
                });
            }

            if (status === 421) {
                setIsValid(false);
                showNotification("error", "Sin talleres", "", null, 4);
            }

            if (status === 425) {
                setIsValid(false);
                data.periodos?.forEach((item) => {
                    if (item.error) {
                        showNotification("error", item.error, "", null, 4);

                        if (item.error.trim() === "El servicio está temporalmente deshabilitado. Intente después de las 00:00.") {
                            setServiceTemporarilyDisabled(true);
                        }
                    }
                });
            }
        }
    };

    const anchor = "right";

    const handleClickTallerInfo = async (event) => {
        setLoading(true);
        await infoTaller();
        setLoading(false);
        toggleDrawer(anchor, true)(event);
    };

    const handleClickPagar = () => {
        pagarTaller().then();
        localStorage.removeItem("idsSeleccionados");
        setInfoCarrito([])
    };

    const handleQuitarDelCarrito = (id) => {
        const nuevoCarrito = infoCarrito.filter(
            (item) => item.id !== id && item.id !== null
        );
        setInfoCarrito(nuevoCarrito);
        const nuevosIds = nuevoCarrito
            .map((item) => item.id)
            .filter((id) => id !== null);

        localStorage.setItem("idsSeleccionados", JSON.stringify(nuevosIds))
        infoTaller().then();
    };

    const list = (anchor) => (
        <>
            <Box
                sx={{width: anchor === 'top' || anchor === 'bottom' ? 'auto' : 380}}
                role="presentation"
                onKeyDown={toggleDrawer(anchor, false)}
            >
                <List>
                    {infoCarrito?.length > 0 && infoCarrito?.map((item, index) => (
                        <ListItem key={item.id || index} disablePadding>
                            <ListItemButton>
                                {!loading && (
                                    <>
                                        {!item.id ? (
                                            <>
                                                <Card sx={{
                                                    minWidth: 350,
                                                    border: '1px solid',
                                                    borderColor: '#4a001f',
                                                    borderRadius: 2,
                                                }}>
                                                    <CardContent>
                                                        <Box sx={{
                                                            maxWidth: 315,
                                                            overflow: 'hidden',
                                                            textOverflow: 'ellipsis',
                                                            whiteSpace: 'nowrap'
                                                        }}>
                                                            <Tooltip title={"Inscripción al Período"}>
                                                                <Typography
                                                                    variant="body2"
                                                                    sx={{
                                                                        color: '#ffffff',
                                                                        backgroundColor: '#4a001f',
                                                                        mb: 1.5,
                                                                        border: '1px solid',
                                                                        borderColor: '#4a001f',
                                                                        borderRadius: 2,
                                                                        padding: 1,
                                                                        textAlign: 'center',
                                                                        fontSize: '1rem',
                                                                    }}
                                                                >
                                                                    Inscripción al Período
                                                                </Typography>
                                                            </Tooltip>
                                                        </Box>

                                                        <Typography variant="body2"
                                                                    sx={{
                                                                        color: 'text.dark', mb: 1.5
                                                                    }}>
                                                            {item.nombretaller}
                                                        </Typography>

                                                        <Typography variant="body2" sx={{color: 'text.dark', mb: 1.5}}>
                                                            Precio por concepto de inscripción: ${item.total} MXN
                                                        </Typography>

                                                        {item.errores && item.errores.map((error, index) => (
                                                            <Typography key={index} variant="body2"
                                                                        sx={{color: '#4a001f', mb: 1.5}}>
                                                                {error}
                                                            </Typography>
                                                        ))}
                                                    </CardContent>
                                                </Card>
                                            </>
                                        ) : (
                                            <>
                                                <Card sx={{
                                                    minWidth: 350,
                                                    border: '1px solid',
                                                    borderColor: '#4a001f',
                                                    borderRadius: 2,
                                                }}>
                                                    <CardContent>
                                                        <Box sx={{
                                                            maxWidth: 300, overflow: 'hidden', minWidth: 315,
                                                            textOverflow: 'ellipsis', whiteSpace: 'nowrap'
                                                        }}>
                                                            <Tooltip title={item.nombretaller}>
                                                                <Typography
                                                                    variant="body2"
                                                                    sx={{
                                                                        color: '#ffffff',
                                                                        backgroundColor: '#4a001f',
                                                                        mb: 1.5,
                                                                        border: '1px solid',
                                                                        borderColor: '#4a001f',
                                                                        borderRadius: 2,
                                                                        padding: 1,
                                                                        textAlign: 'center',
                                                                        fontSize: '1rem',
                                                                        whiteSpace: 'normal',
                                                                        wordBreak: 'break-word',
                                                                        maxWidth: '100%',
                                                                    }}
                                                                >
                                                                    {item.nombretaller}
                                                                </Typography>
                                                            </Tooltip>
                                                        </Box>

                                                        <Box sx={{maxWidth: 315}}>
                                                            <Typography
                                                                variant="body2"
                                                                sx={{
                                                                    mb: 2,
                                                                    border: '1px solid',
                                                                    borderColor: '#4a001f',
                                                                    borderRadius: 2,
                                                                    padding: 1,
                                                                    textAlign: 'left',
                                                                    whiteSpace: 'pre-line',
                                                                    wordBreak: 'break-word',
                                                                }}
                                                            >
                                                                {`Precio por concepto Taller: ${formatoMXN.format(item.total)} MXN\nDescuento:  ${formatoMXN.format(item.descuento)} MXN`}
                                                                <Box sx={{display: 'flex', justifyContent: 'flex-end'}}>
                                                                    <IconButton
                                                                        onClick={() => handleQuitarDelCarrito(item.id)}
                                                                        sx={{color: '#4a001f'}}
                                                                        aria-label="Quitar del carrito"
                                                                    >
                                                                        <DeleteIcon/>
                                                                    </IconButton>
                                                                </Box>
                                                            </Typography>
                                                        </Box>

                                                        {item.errores && item.errores.map((error, index) => (
                                                            <Typography key={index} variant="body2"
                                                                        sx={{color: 'red', mb: 1.5}}>
                                                                Nota: {error}
                                                            </Typography>
                                                        ))}
                                                    </CardContent>
                                                </Card>
                                            </>
                                        )}
                                    </>
                                )}
                            </ListItemButton>
                        </ListItem>
                    ))}
                </List>
            </Box>

            {(!loading && !serviceTemporarilyDisabled) ? (
                <Card sx={{
                    minWidth: 200,
                    border: '1px solid',
                    borderColor: '#4a001f',
                    margin: 2,
                    borderRadius: 2,
                }}>
                    <CardContent>
                        <Box>
                            {
                                cartStorage.length === 0 ? (
                                    <>
                                        <Typography
                                            variant="body2"
                                            sx={{
                                                color: '#4a001f',
                                                mb: 1.5,
                                                border: '1px solid',
                                                borderColor: '#4a001f',
                                                borderRadius: 2,
                                                padding: 1,
                                                textAlign: 'center',
                                                fontSize: '1rem',
                                            }}
                                        >
                                            Seleccione un taller
                                        </Typography>
                                    </>
                                ) : (<>
                                    <Typography
                                        variant="body2"
                                        sx={{
                                            mb: 2,
                                            border: '1px solid',
                                            borderColor: '#4a001f',
                                            borderRadius: 2,
                                            padding: 1,
                                            textAlign: 'left',
                                            whiteSpace: 'pre-line',
                                            wordBreak: 'break-word',
                                        }}
                                    >
                                        {`Total final:   ${formatoMXN.format(totalCarrito  ? totalCarrito : 0)}  MXN\nDescuento Final:  ${formatoMXN.format(descCarrito ? descCarrito : 0)} MXN`}
                                    </Typography>
                                </>)}
                        </Box>

                        {isValid && (
                            <button
                                className="bg-rosaClaro p-2 rounded border w-100"
                                onClick={(event) => {
                                    toggleDrawer(anchor, false)(event);
                                    handleClickPagar();
                                }}
                            >
                                Generar línea de captura
                            </button>
                        )}
                    </CardContent>
                </Card>
            ) : (
                <>
                    {
                        serviceTemporarilyDisabled && (
                            <div
                                style={{
                                    maxWidth: 420,
                                    margin: '0 auto',
                                    mt: 4,
                                    p: 2,
                                    textAlign: 'center',
                                }}
                            >
                                <Box sx={{ display: 'flex', justifyContent: 'center', mb: 1 }}>
                                    <ShoppingCartOutlinedIcon sx={{ fontSize: 48, color: 'text.secondary' }} />
                                </Box>

                                <CardContent>
                                    <Typography variant="h6" component="h2" gutterBottom>
                                        Carrito no disponible
                                    </Typography>

                                    <Typography variant="body2" color="text.secondary">
                                        En este momento el carrito de compras no está disponible.
                                        Por favor, inténtalo de nuevo más tarde.
                                    </Typography>
                                </CardContent>
                            </div>
                        )
                    }
                </>
            )}
            <br></br>
        </>
    );

    return (
        <>
            <Backdrop
                open={loading}
                sx={{
                    zIndex: 9999,
                    color: '#fff',
                    backgroundColor: 'rgba(0, 0, 0, 0.5)',
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    width: '100vw',
                    height: '100vh',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                }}
            >
                <CircularProgress color="inherit"/>
            </Backdrop>
            {['right'].map((anchor) => (
                <React.Fragment key={anchor}>
                    <Box>
                        <>
                            {
                                cartStorage.length === 0 ? (
                                    <>
                                    </>
                                ) : (
                                    <>
                                        <IconButton onClick={(event) => handleClickTallerInfo(event, "right")}>
                                            <Badge
                                                badgeContent={Math.max((cartStorage?.length || 0))}
                                                sx={{color: '#4a001f'}}
                                            >
                                                <ShoppingCartIcon sx={{color: '#4a001f', fontSize: 26}}/>
                                            </Badge>
                                        </IconButton>
                                    </>
                                )
                            }
                        </>
                    </Box>

                    <Drawer
                        anchor={anchor}
                        open={state[anchor]}
                        onClose={toggleDrawer(anchor, false)}
                        PaperProps={{
                            sx: {
                                width: 380,
                                display: 'flex',
                                flexDirection: 'column',
                            }
                        }}
                    >
                        <Box sx={{overflowY: 'auto', flexGrow: 1}}>
                            <Box sx={{display: 'flex', justifyContent: 'flex-end', p: 0}}>
                                <IconButton onClick={(event) => {
                                    toggleDrawer(anchor, false)(event);
                                }} sx={{color: '#4a001f'}}>
                                    <CloseIcon/>
                                </IconButton>
                            </Box>
                            {list(anchor)}
                        </Box>
                    </Drawer>
                </React.Fragment>
            ))}
        </>
    );
}
